import React from 'react';
import { Platform } from 'react-native';
import { Link } from 'expo-router';
import { Button, ButtonText } from '@/components/gluestack/button';
import { HugeIconsWrapper } from '@/components/ui/HugeIconsWrapper';
import { LinkSquare02Icon } from '@hugeicons-pro/core-stroke-rounded';
import { useOpenWebPage } from '@/hooks/useOpenWebPage';

interface IExternalLinkButtonProps {
  /** Without a URL the button renders but does nothing (e.g. no subscription to manage yet) */
  url?: string | null;
  label: string;
}

/**
 * Link-style button to an external page: a real link opening a new tab on web (so it can be
 * middle-clicked or copied), the themed in-app browser on native.
 */
export function ExternalLinkButton({ url, label }: IExternalLinkButtonProps) {
  const openWebPage = useOpenWebPage();

  // Not asChild: Link only forwards target to the anchor it renders itself (via hrefAttrs)
  if (Platform.OS === 'web' && url) {
    return (
      <Link
        href={url as any}
        target="_blank"
        rel="noopener noreferrer"
        className="flex h-10 flex-row items-center gap-2 self-start text-base font-semibold text-primary-500 web:hover:underline">
        <HugeIconsWrapper icon={LinkSquare02Icon} size={18} className="color-primary-500" />
        {label}
      </Link>
    );
  }

  return (
    <Button
      variant="link"
      action="primary"
      onPress={url ? () => openWebPage(url) : undefined}
      className="self-start">
      <HugeIconsWrapper icon={LinkSquare02Icon} size={18} className="color-primary-500" />
      <ButtonText className="text-primary-500">{label}</ButtonText>
    </Button>
  );
}
